import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AccessModal from './components/AccessModal';
import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import DocumentsSection from './components/DocumentsSection';
import TokenomicsSection from './components/TokenomicsSection';
import MediaSection from './components/MediaSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import AdminPanel from './components/AdminPanel';
import AdminLogin from './components/AdminLogin';

function HomePage({ hasAccess, onAccessGranted }) {
  return (
    <div className="App">
      {!hasAccess && <AccessModal onAccessGranted={onAccessGranted} />}
      <Navigation />
      <HeroSection />
      <DocumentsSection />
      <TokenomicsSection />
      <MediaSection />
      <CTASection />
      <Footer />
    </div>
  );
}

function AdminPage({ isAdminLoggedIn, onAdminLoginSuccess, onAdminLogout }) {
  if (isAdminLoggedIn) {
    return <AdminPanel onBack={onAdminLogout} />;
  }
  return <AdminLogin onLoginSuccess={onAdminLoginSuccess} />;
}

function App() {
  const [hasAccess, setHasAccess] = useState(false);
  const [isAdminLoggedIn, setIsAdminLoggedIn] = useState(false);

  useEffect(() => {
    const granted = localStorage.getItem('tempesAccessGranted') === 'true';
    setHasAccess(granted);

    const adminLoggedIn = localStorage.getItem('adminLoggedIn') === 'true';
    setIsAdminLoggedIn(adminLoggedIn);
  }, []);

  const handleAccessGranted = () => {
    setHasAccess(true);
  };

  const handleAdminLoginSuccess = () => {
    setIsAdminLoggedIn(true);
  };

  const handleAdminLogout = () => {
    setIsAdminLoggedIn(false);
    localStorage.removeItem('adminLoggedIn');
  };

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <HomePage
              hasAccess={hasAccess}
              onAccessGranted={handleAccessGranted}
            />
          }
        />
        <Route
          path="/admin"
          element={
            <AdminPage
              isAdminLoggedIn={isAdminLoggedIn}
              onAdminLoginSuccess={handleAdminLoginSuccess}
              onAdminLogout={handleAdminLogout}
            />
          }
        />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
